// src/components/MailchimpSignup.js
import React, { useState } from "react";
import "../pages/Closed.css"; // ✅ chemin correct

// Champ piège (honeypot) : invisible pour un humain, rempli par les robots.
// Le nom doit rester identique à HONEYPOT_FIELD dans api/subscribe.js.
const HONEYPOT_FIELD = "website";

// Sort le champ de l'écran sans le retirer du DOM. On n'utilise pas
// display:none ni visibility:hidden : beaucoup de bots les détectent et
// sautent le champ, ce qui viderait le piège de son intérêt.
const honeypotWrapStyle = {
  position: "absolute",
  left: "-9999px",
  width: "1px",
  height: "1px",
  overflow: "hidden",
};

export default function MailchimpSignup({ cta = "notify me" }) {
  const [email, setEmail] = useState("");
  const [honeypot, setHoneypot] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | ok | error
  const [msg, setMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    setMsg("");

    try {
      const res = await fetch("/api/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, [HONEYPOT_FIELD]: honeypot }),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok || !data.ok) {
        setStatus("error");
        setMsg(data?.error || "Something went wrong");
        return;
      }

      setStatus("ok");
      setMsg("you’re on the list.");
      setEmail("");
    } catch {
      setStatus("error");
      setMsg("Network error");
    }
  };

  return (
    <form className="closedVideo__form" onSubmit={submit}>
      {/* Piège à bots — invisible, hors du parcours clavier et des lecteurs
          d'écran. Un humain ne peut ni le voir ni l'atteindre. */}
      <div style={honeypotWrapStyle} aria-hidden="true">
        <label htmlFor="gs-website">Ne pas remplir ce champ</label>
        <input
          id="gs-website"
          name={HONEYPOT_FIELD}
          type="text"
          value={honeypot}
          onChange={(e) => setHoneypot(e.target.value)}
          tabIndex={-1}
          autoComplete="off"
        />
      </div>

      <input
        className="closedVideo__input"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="email"
        required
      />
      <button
        className="closedVideo__btn"
        type="submit"
        disabled={status === "loading"}
      >
        {status === "loading" ? "..." : cta}
      </button>

      {status !== "idle" && (
        <div className="closedVideo__success" style={{ marginTop: 12 }}>
          {msg}
        </div>
      )}
    </form>
  );
}
